import { ButtonHTMLAttributes } from 'react';
import cx from 'classnames';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  theme?: 'light' | 'dark';
}

export function PauseButton({ theme = 'light', className, ...props }: Props) {
  return (
    <button
      className={cx(
        'group relative flex h-10 w-10 items-center justify-center rounded-full focus:outline-none focus:ring-2 focus:ring-[#FF9446] active:opacity-70',
        theme === 'light'
          ? 'bg-[#003835] text-[#00D9B4]'
          : 'bg-[#00D9B4] text-[#003835]',
        className
      )}
      tabIndex={0}
      {...props}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
      >
        <rect
          x="21.1431"
          y="13.5"
          width="4.28571"
          height="14.2857"
          fill="currentColor"
        />
        <rect
          x="14"
          y="13.5"
          width="4.28571"
          height="14.2857"
          fill="currentColor"
        />
      </svg>
    </button>
  );
}
